import { Button } from "primereact/button";

const ListCourseLink = ({ courseLinkData }) => {
    const redirectLink = (link) => {
        window.open(link, "_blank");
    }
    return (
        <>
        <hr />
        <div className="card">
            {courseLinkData.map((link, index) => (
                <div className="flex flex-wrap p-field font-bold block">
                    <div className="col-10">
                        <label htmlFor="text" className="font-bold block mb-2 training-heading mt-2">{link}</label>
                    </div>
                    <div className="col-2">
                        <Button icon="pi pi-eye" className="p-button p-button-primary p-button-icon-only" aria-label="View" tooltip="View Details" tooltipOptions={{ position: "top" }} onClick={() => redirectLink(link)} />
                    </div>
                </div>
            ))}
        </div>
        </>
    );
};

export default ListCourseLink;
